.badge {
  display: block;
  padding: 0 8px;
  position: absolute;
  z-index: 1;
  background-color: var(--tuna-palette-primary-light);
  color: var(--tuna-palette-primary-contrastText);
}

.waveformContainer {
  flex: 1;
}

.waveformBackground {
  fill: var(--tuna-palette-primary-light);
}

.waveformProgress {
  fill: var(--tuna-palette-success-main);
}

.wave {
  flex: 1;
  flex-direction: column;
  display: flex;
  font-size: var(--tuna-typography-fontSize-xs);
}
